export const sortByDisplayOrder = <T extends { displayOrder: number }>(
  items: T[]
): T[] => [...items].sort((a, b) => a.displayOrder - b.displayOrder);
